import { Component, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy } from '@angular/core';
import { ProblemChildPatchesResponse } from '../../../../../../../core/models/analytics/vss-models';
import { DatatableComponent } from '../../../../../../../core/components/datatable/datatable.component';
import { environment } from '../../../../../../../../environments/environment';
import { checkIsDemoOrg } from 'src/app/core/models/organizations';

export interface ProblemChildPatch {
  cve: string;
  assets: number;
  daysOld: number;
  severity: 'danger' | 'warning' | 'info';
}

function showdaysoldlink(data:any, type:any, row:any, meta:any){ 
  return data ? '<span class="badge bg-'+row['severity']+'"> '+data+' </span>': ''; 
};


@Component({
  selector: 'app-problem-child-patches',
  templateUrl: './problem-child-patches.component.html',
  styleUrls: ['./problem-child-patches.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, DatatableComponent],
})
export class ProblemChildPatchesComponent {
  // Accept filters as input from parent
  filters = input<any>({});

  problemChildPatchesResponse = input.required<ProblemChildPatchesResponse>();
  datatableUrl = `${environment.apiUrl}/v1/vicarius/datatables/problemchildpatches/`;
  last_fetch_datetime = signal<Date>(new Date());
  datatableColumns = [
                {data: "cve", name: "cve", title: "CVE", type: "string", visible: true},
                {data: "assets", name: "assets", title: "Assets", type: "number", visible: true},
                {data: "daysOld", name: "daysOld", title: "Days Old", type: "string", visible: true,
                  render: showdaysoldlink
                },
                ];

  public onSuccess(){
    const parent = this;
    return function (data:any){
          const lastdate = new Date(data['last_fetch_datetime']);
          parent.last_fetch_datetime.set(lastdate);
    };
  }

}
